module.exports = __webpack_public_path__ + "static/media/logo-gergo-branco.99d6065b.png";